import { useFindAllCompaniesQuery } from '../../api/api-hooks';
import FilterBar from '../../components/FilterBar';
import {
  CircularProgress,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { Autocomplete } from '@mui/material';
import { DemosItemFilter } from './demosTypes';
import { filterConstraintChecker } from './demosUtils';

interface Props {
  filters: DemosItemFilter;
  setFilters: React.Dispatch<any>;
  initialFilters: DemosItemFilter;
}

const DemosFilterBar = ({ filters, setFilters, initialFilters }: Props) => {
  const { data: companies } = useFindAllCompaniesQuery({});
  if (companies === undefined) return <CircularProgress></CircularProgress>;

  return (
    <>
      <FilterBar
        filters={filters}
        setFilters={setFilters}
        initialFilters={initialFilters}
        filterConstraintChecker={filterConstraintChecker}
        children={(
          handler: (event: any, value?: any, label?: string) => void
        ) => [
          <Autocomplete
            onChange={(event, value) => {
              handler(event, value, 'company');
            }}
            value={filters.company}
            options={companies}
            getOptionLabel={(company) => company.companyName}
            style={{ width: 300 }}
            renderInput={(params) => (
              <TextField
                {...params}
                label='Filter By Company'
                name='company'
                variant='outlined'
                id='company'
              />
            )}
          />,
          <TextField
            name='serial'
            label='Filter By Serial'
            variant='outlined'
            value={filters.serial}
            onChange={handler}
          />,
          <Typography>Start:</Typography>,
          <TextField
            name='startDate'
            variant='outlined'
            type='date'
            value={filters.startDate}
            onChange={handler}
          />,
          <Typography>End:</Typography>,
          <TextField
            name='endDate'
            variant='outlined'
            type='date'
            value={filters.endDate}
            onChange={handler}
          />,
          <Select
            name='demoActive'
            value={filters.demoActive}
            variant='outlined'
            displayEmpty={true}
            renderValue={(value: any) => (value ? value : 'Filter By Status')}
            onChange={handler}
          >
            <MenuItem value='Active'>Active</MenuItem>
            <MenuItem value='Expired'>Expired</MenuItem>
            <MenuItem value='None'>None</MenuItem>
          </Select>,
        ]}
      />
    </>
  );
};

export default DemosFilterBar;
